export var getStateKey = (child, key) => {
  var stateKey = key;
  if (child && child.props.stateKey) {
    stateKey = child.props.stateKey.replace(/ /g, '-');
  }
  return stateKey;
};